/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { BORDER_STYLE } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID, getSCSSDifference } from "src/libs/utilities"
import { DataContentContent, ILandingContent, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { DataContentPrimitive } from "../../primitive"
import { getDifferent, IHTMLProps } from "../HTML"

/* Protopia Ecosystem component */ 
const Incut = (props: IHTMLProps): JSX.Element => {
    const {data} = props
    const [borderRound]     = useState<string>(getCssDemention( data.incutBorder?.borderRound?.border, "0" ))
    const [gap]             = useState<string>(getCssDemention( data.gap, "20px" ))
    useEffect(() => {
        addCSSClass(
            `landing-html-${data.id}`,
            `.incut1-${data.id} { 
                padding: ${ gap };
                width:  ${getCssDemention( data.incutWidth,  "350px" )};
                height: ${getCssDemention( data.incutHeight, "300px" )};
                --border: 1px solid var(--force-contast-color); 
                border-width: ${data.incutBorder?.borderWidth || 0}px;
                border-color: ${data.incutBorder?.borderColor};
                border-style: ${data.incutBorder?.borderStyle || BORDER_STYLE.SOLID} ;
                border-radius: ${borderRound};
            }
            `
        )
        
        return () => {
            removeCSSClass(`landing-html-${data.id}`)
        }
    },[ borderRound ])
    if( !data.incut ) {
        return <></>
    }

    const incut: DataContentContent =  { ...data.incut }
    const meats: ILandingContent[] = !!incut && Array.isArray(incut.data)
        ?
        incut.data
        :
        []

    const ggp: string = `${ getDifferent( meats[0]?.type ) + (data.incutBorder?.borderWidth || 0) * 2 }px`

    const incutMeats = meats.map((meat: ILandingContent, i) => {
        const _gap = `${ getDifferent( meats[i]?.type ) + (data.incutBorder?.borderWidth || 0) * 2 }px` 
        return {
            ...meat,
            width:  meat.width  || getSCSSDifference(data.incutWidth || 350,  _gap ),
            height: meat.height || getSCSSDifference(data.incutHeight || 300, _gap ),
            incut: [],
            data:  Array.isArray(meat.data)
                ?
                meat.data?.map((dd:any) => ({
                    ...dd, 
                    width: meat.width   || parseInt(getSCSSDifference(data.incutWidth  || 350, _gap )), 
                    height: meat.height || parseInt(getSCSSDifference(data.incutHeight || 300, _gap ))
                }))
                :
                []
        } as ILandingContent
    })

    const primitive: DataContentContent = { 
        ...incut, 
        position: {
            width:  getSCSSDifference(data.incutWidth || 350,  ggp ),
            height: getSCSSDifference(data.incutHeight || 300, ggp ),
        },
        primitive: {
            data: incutMeats,
            position: {
                width: 0,
                height: 0,
            },
        }, 
        type: LANDING_TYPE_CONTENT.DATA_CONTENT,
        "data-primitive-type":  LANDING_TYPE_CONTENT.DATA_CONTENT
    }
    return <div className={`landing-incut-${data.incutPosition || "right"} incut1-${data.id}`}>
        <DataContentPrimitive
            primitive={ primitive }
        />
    </div>
}
export default Incut